module.exports = __webpack_public_path__ + "img/expiration-extension-mb.80607846.png";